module.exports = __webpack_public_path__ + "img/media1.eb2c2af3.jpeg";